import { mount } from "utils";
import { FireMapDetail } from "../components";

mount(FireMapDetail, "fire_map_detail");
